import { GiftStatus } from '@/api/gifts';
import { supplierStatus } from '@/api/suppliers';
import { renderStatusText } from '@/lib/utils';

function TextInActive({ status }: { status: supplierStatus | GiftStatus }) {
  return (
    <span className={renderStatusText(status).className}>
      {' '}
      {(status === supplierStatus.INACTIVE ||
        status === GiftStatus.INACTIVE) && (
        <>({renderStatusText(status).label})</>
      )}
    </span>
  );
}

export default TextInActive;
